import {env} from '@/helper/env';
import cookies from 'js-cookie';

const KEY = 'USER_USED_UID';
const COOKIE_USER_KEY = 'px_uid';

export function readUsedUIDs() {
  if (env.isServer) {
    return [];
  }
  const uids = (localStorage.getItem(KEY) || '')
    .split(',')
    .filter(Boolean)
    .map((uid) => parseInt(uid));

  const currentUid = uids?.length && uids?.[0];
  if (currentUid) {
    writeUsedUIDsToCookie(currentUid);
  }
  return uids;
}

export function updateUsedUIDs(userId) {
  if (env.isServer) {
    return;
  }
  if (userId !== 0) {
    const userIds = readUsedUIDs();
    // 当前用户放在最前面
    localStorage.setItem(KEY, [userId, ...userIds.filter((o) => o !== userId)].join(','));
    writeUsedUIDsToCookie(userId);
  }
}

export function hasUsedUID() {
  return readUsedUIDs().length > 0;
}

export function writeUsedUIDsToCookie(userId) {
  cookies.set(COOKIE_USER_KEY, userId);
}
